export { default as translations } from './translations.json';

/**
 * Get listing certifications (claimed).
 * @param {Object|null} listing
 * @returns {string[]}
 */
export const getListingCertifications = (listing) =>
  listing?.attributes?.publicData?.certifications || [];

/**
 * Get verified certifications (admin-confirmed).
 * @param {Object|null} listing
 * @returns {string[]}
 */
export const getVerifiedCertifications = (listing) =>
  listing?.attributes?.metadata?.verifiedCertifications || [];

/**
 * Check if a certification is verified.
 * @param {Object|null} listing
 * @param {string} certId
 * @returns {boolean}
 */
export const isCertificationVerified = (listing, certId) =>
  getVerifiedCertifications(listing).includes(certId);

/**
 * Get certifications with verified status.
 * @param {Object|null} listing
 * @returns {{ id: string, verified: boolean }[]}
 */
export const getCertificationsWithStatus = (listing) =>
  getListingCertifications(listing).map(id => ({
    id,
    verified: isCertificationVerified(listing, id),
  }));
